import { VStack } from '@chakra-ui/react';
import { EmailBlockSection } from '../../../components/EmailBlockSection';
import type { InterviewCommPanelBaseProps } from './types';
import { TemplatedEmail } from '../../../components/TemplatedEmail';
import { IcsAttachmentCheckbox } from '../../../components/IcsAttachmentCheckbox';

export const CandidateCommunicationPanel = ({
  state,
  dispatch,
  fieldErrors,
  candidateCalendarTemplateOptions,
  candidateEmailTemplateOptions,
  fromOptions,
  ccBccOptions,
  candidateCalendarVariables,
  candidateEmailVariables,
  uploadInlineImage,
}: InterviewCommPanelBaseProps) => (
  <VStack align="stretch" spacing="4" w="100%">
    <EmailBlockSection
      title="Candidate's calendar invite"
      sectionId="interview-comm-candidate-calendar"
    >
      <TemplatedEmail
        className="w-full"
        showFrom={false}
        showTo={false}
        showSubject={false}
        enableCcBcc={false}
        showTemplate
        showEditor
        editorVariant="calendarInvite"
        variables={candidateCalendarVariables}
        templateOptions={candidateCalendarTemplateOptions}
        applyTemplateBodyToEditor
        value={state.candidateCalendar}
        onChange={(value) =>
          dispatch({ type: 'SET_CANDIDATE_CALENDAR', payload: value })
        }
        errors={fieldErrors.candidateCalendar}
        placeholders={{ template: 'Select a template' }}
      />
    </EmailBlockSection>

    <EmailBlockSection
      title="Candidate's email"
      sectionId="interview-comm-candidate-email"
      showSwitch
      switchChecked={state.candidateEmailEnabled}
      onSwitchChange={(checked) =>
        dispatch({ type: 'SET_CANDIDATE_EMAIL_ENABLED', payload: checked })
      }
    >
      {state.candidateEmailEnabled ? (
        <>
          <TemplatedEmail
            className="w-full"
            showFrom
            showTo={false}
            showSubject
            enableCcBcc
            showTemplate
            showEditor
            editorVariant="richEmail"
            variables={candidateEmailVariables}
            attachments={state.candidateEmailAttachments}
            onAttachmentsChange={(items) =>
              dispatch({
                type: 'SET_CANDIDATE_EMAIL_ATTACHMENTS',
                payload: items,
              })
            }
            templateOptions={candidateEmailTemplateOptions}
            fromOptions={fromOptions}
            ccBccOptions={ccBccOptions}
            applyTemplateBodyToEditor
            value={state.candidateEmail}
            onChange={(value) =>
              dispatch({ type: 'SET_CANDIDATE_EMAIL', payload: value })
            }
            errors={fieldErrors.candidateEmail}
            placeholders={{
              from: 'Select from',
              subject: 'Additional email for context',
              template: 'Select a template',
            }}
            uploadInlineImage={uploadInlineImage}
          />
          <IcsAttachmentCheckbox
            checked={state.candidateIcsEnabled}
            onChange={(v) =>
              dispatch({ type: 'SET_CANDIDATE_ICS_ENABLED', payload: v })
            }
          />
        </>
      ) : null}
    </EmailBlockSection>
  </VStack>
);
